import { render } from "./SimpleBreadcrumbs.vue?vue&type=template&id=53490e05&ts=true&lang=pug"
import script from "./SimpleBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleBreadcrumbs.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__